import React from 'react';
import {NavLink} from "react-router-dom";
import {FieldTimeOutlined, PlusOutlined} from "@ant-design/icons";

function Main(props) {
    return (
        <div className="conteiner-fluid h-100">
            <div className="row">
                <div className="col-12">
                    SFR > <NavLink to="/sfr/gidromodul">Gidromodul</NavLink>
                </div>
            </div>
            <div className="d-flex align-items-center h-100">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 mb-5">
                            <NavLink to="/sfr/gidromodul/old" style={{maxWidth:"200px"}} className="mx-auto btn btn-lg btn-primary d-flex align-items-center mb-2">
                                <FieldTimeOutlined /> &nbsp;&nbsp;
                                Eski xisobotlar
                            </NavLink>
                        </div>
                        <div className="col-12">
                            <NavLink to="/sfr/gidromodul/new" style={{maxWidth:"200px"}} className="mx-auto btn btn-lg btn-primary d-flex align-items-center">
                                <PlusOutlined /> &nbsp;&nbsp;
                                Yangi xisobot
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;